import { render, staticRenderFns } from "./InputSeparatore3.vue?vue&type=template&id=38a40fab&scoped=true&"
import script from "./InputSeparatore3.vue?vue&type=script&lang=js&"
export * from "./InputSeparatore3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a40fab",
  null
  
)

export default component.exports